import _ from 'lodash';
import BaseStore from 'vendor/cnpm/fluxible.v0-4/addons/BaseStore';

import createLinkedModels from 'bundles/catalogP/lib/createLinkedModels';
import Memberships from 'bundles/catalogP/models/memberships';

const SERIALIZED_PROPS = ['loaded', 'rawMemberships'];

class CertificateStore extends BaseStore {
  static storeName = 'CertificateStore';

  static handlers = {
    LOAD_MEMBERSHIPS(rawMemberships: $TSFixMe) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'loaded' does not exist on type '{ LOAD_M... Remove this comment to see the full error message
      this.loaded = true;
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'rawMemberships' does not exist on type '... Remove this comment to see the full error message
      this.rawMemberships = rawMemberships;
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'initializeMembershipsModel' does not exi... Remove this comment to see the full error message
      this.initializeMembershipsModel();

      // @ts-expect-error ts-migrate(2339) FIXME: Property 'emitChange' does not exist on type '{ LO... Remove this comment to see the full error message
      this.emitChange();
    },
  };

  constructor(dispatcher: $TSFixMe) {
    super(dispatcher);

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'loaded' does not exist on type 'Certific... Remove this comment to see the full error message
    this.loaded = false;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'memberships' does not exist on type 'Cer... Remove this comment to see the full error message
    this.memberships = {};
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'rawMemberships' does not exist on type '... Remove this comment to see the full error message
    this.rawMemberships = null;
  }

  dehydrate() {
    return _.pick(this, ...SERIALIZED_PROPS);
  }

  rehydrate(state: $TSFixMe) {
    Object.assign(this, _.pick(state, ...SERIALIZED_PROPS));
    this.initializeMembershipsModel();
  }

  hasLoaded() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'loaded' does not exist on type 'Certific... Remove this comment to see the full error message
    return this.loaded;
  }

  initializeMembershipsModel() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'rawMemberships' does not exist on type '... Remove this comment to see the full error message
    if (this.rawMemberships) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'rawMemberships' does not exist on type '... Remove this comment to see the full error message
      const memberships = createLinkedModels(Memberships.prototype.resourceName, this.rawMemberships);

      memberships.each((membership: $TSFixMe) => {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'memberships' does not exist on type 'Cer... Remove this comment to see the full error message
        this.memberships[membership.get('course').get('id')] = membership;
      });
    }
  }

  passedWithVerification(courseId: $TSFixMe) {
    /*
     * NOTE: membership.hasVerifiedCertificate returns true if a user has passed the course with
     * verification (even if a course certificate has not been issued)
     */
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'memberships' does not exist on type 'Cer... Remove this comment to see the full error message
    const membership = this.memberships[courseId];
    return membership && membership.hasVerifiedCertificate();
  }

  /**
   * Returns true if certificate exists, false if membership does not exist or if certificate has not yet been earned.
   * Note that this behavior differs from many other common store functions - this function will never return undefined
   * in the case that the membership does not exist.
   */
  hasCertificate({ courseId }: $TSFixMe) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'memberships' does not exist on type 'Cer... Remove this comment to see the full error message
    const membership = this.memberships[courseId];
    return !!membership && typeof membership.get('vcMembership.certificateCode') !== 'undefined';
  }

  getCertificateLink({ courseId }: $TSFixMe) {
    if (this.hasCertificate({ courseId })) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'memberships' does not exist on type 'Cer... Remove this comment to see the full error message
      return this.memberships[courseId].getFullCertificateLink();
    }

    return null;
  }

  getCourseCertificateGrantTime({ courseId }: $TSFixMe) {
    if (this.hasCertificate({ courseId })) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'memberships' does not exist on type 'Cer... Remove this comment to see the full error message
      return this.memberships[courseId].get('vcMembership.grantedAt');
    }

    return null;
  }

  getCourseGradeTimestamp({ courseId }: $TSFixMe) {
    if (this.passedWithVerification(courseId)) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'memberships' does not exist on type 'Cer... Remove this comment to see the full error message
      return this.memberships[courseId].getCourseGrade().timestamp;
    }

    return null;
  }

  /* Returns the course grade timestamp if a certificate has not been issued yet, otherwise returns
   * the certificate grant time.
   */
  getCourseCompletionTime({ courseId }: $TSFixMe) {
    if (this.passedWithVerification(courseId)) {
      return this.hasCertificate({ courseId })
        ? this.getCourseCertificateGrantTime({ courseId })
        : this.getCourseGradeTimestamp({ courseId });
    }

    return null;
  }
}

export default CertificateStore;
